/**
 * Session-storage marker for the product restored after a PayPal redirect.
 * Written by handlePaypalRedirect, read by the paywalls to avoid overwriting
 * the restored product, and cleared once it lands in the store.
 */

export function getPaypalRestoreProductId(): string {
  try {
    return window.sessionStorage.getItem('paypal_restore_product_id') || '';
  } catch (_) {
    return '';
  }
}

export function clearPaypalRestoreProductId(): void {
  try {
    window.sessionStorage.removeItem('paypal_restore_product_id');
  } catch (_) {
    void 0;
  }
}
